import React, { useRef } from 'react';
import './Status.css';

const Status = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  
  return (
    <div className="status-container">
      <div className="redirect-message">
        <p>Please click the link below to view the system status page in a new tab:</p>
        <p>
          <a 
            ref={linkRef}
            href="https://mycache.statuspage.io/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Open System Status
          </a>
        </p>
      </div>
    </div>
  );
};

export default Status; 